// extracted by mini-css-extract-plugin
export default {"displayRating":"Rating--displayRating--5e15f7"};